import React, { useState } from "react";
import ReactPaginate from "react-paginate";
import RankedTable from "../layout/RankedTable";
import AddVisualsDialog from "./AddVisualsDialog";

const PAGE_SIZE = 15;

const PersonaManagementTable = ({
  searchText,
  setSearchText,
  filteredPersonas,
  onDeletePersona,
  onEditPersona,
  onAddReport,
}) => {
  const [currentPage, setCurrentPage] = useState(0);

  const pageCount = Math.ceil(filteredPersonas.length / PAGE_SIZE);
  const currentData = filteredPersonas.slice(currentPage * PAGE_SIZE, (currentPage + 1) * PAGE_SIZE);

  const handleSearch = (e) => { setSearchText(e.target.value); setCurrentPage(0); };

  const btnStyle = (bg, color, border) => ({
    padding: "4px 10px", borderRadius: "6px", border: `1px solid ${border}`,
    background: bg, cursor: "pointer", color, fontSize: "11px", fontWeight: 600,
  });

  return (
    <div className="pb-2">
      <div className="flex items-center justify-between mb-3 flex-wrap gap-3 px-1">
        <div className="flex items-center gap-3">
          <input
            type="text"
            className="text-sm border border-gray-200 rounded-lg px-3 py-2 bg-white text-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-100"
            style={{ minWidth: "280px" }}
            placeholder="Search by persona name"
            value={searchText}
            onChange={handleSearch}
          />
       
        </div>
        {pageCount > 1 && (
          <ReactPaginate
            previousLabel={"‹"} nextLabel={"›"} breakLabel={"..."}
            pageCount={pageCount} marginPagesDisplayed={1} pageRangeDisplayed={3}
            onPageChange={({ selected }) => setCurrentPage(selected)}
            forcePage={currentPage}
            containerClassName={"pagination"} pageClassName={"page-item"} pageLinkClassName={"page-link"}
            previousClassName={"page-item"} previousLinkClassName={"page-link"}
            nextClassName={"page-item"} nextLinkClassName={"page-link"}
            breakClassName={"page-item"} breakLinkClassName={"page-link"} activeClassName={"active"}
          />
        )}
      </div>

      <RankedTable
        columns={[
          { label: "Persona Name", width: "22%" },
          { label: "Created By", width: "18%" },
          { label: "Created At", width: "18%" },
          { label: "Actions", width: "20%" },
        ]}
        rows={currentData}
        emptyText="No matching personas found."
        renderRow={(persona) => (<>
          <td className="px-5 py-3 font-medium text-gray-800 text-xs">{persona.name}</td>
          <td className="px-5 py-3 text-gray-500 text-xs">{persona.createdBy}</td>
          <td className="px-5 py-3 text-gray-400 text-xs">{persona.createdAt}</td>
          <td className="px-5 py-3">
            <div className="flex items-center justify-start gap-2 flex-wrap">
              <AddVisualsDialog personaName={persona.name} personaId={persona.id} />
              <button type="button" style={btnStyle("#d8f5e9", "#14653a", "#14653a")}
                onMouseEnter={e => e.currentTarget.style.opacity = "0.85"}
                onMouseLeave={e => e.currentTarget.style.opacity = "1"}
                onClick={() => onAddReport(persona)}>Add Report</button>
              <button type="button" style={btnStyle("#eff6ff", "#1d4ed8", "#bfdbfe")}
                onMouseEnter={e => e.currentTarget.style.background = "#dbeafe"}
                onMouseLeave={e => e.currentTarget.style.background = "#eff6ff"}
                onClick={() => onEditPersona(persona)}>Edit</button>
              <button type="button" style={btnStyle("#fff5f5", "#dc2626", "#fecaca")}
                onMouseEnter={e => e.currentTarget.style.background = "#fee2e2"}
                onMouseLeave={e => e.currentTarget.style.background = "#fff5f5"}
                onClick={() => onDeletePersona(persona.id)}>Delete</button>
            </div>
          </td>
        </>)}
      />
    </div>
  );
};

export default PersonaManagementTable;
